import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import SEO from '../components/SEO';
import { FadeIn, PageHero } from '../components/PageComponents';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { geoPages } from '../data/geoData';

const d = geoPages.gidsInterimFinance;

const GidsInterimFinancePage = () => (
  <main className="pt-28 min-h-screen">
    <SEO title={d.title + ' - Staffing Force'} description={d.metaDesc} keywords="interim finance, gids, tarieven, financial controller, business controller, CFO, staffing force nederland" />
    <PageHero label="Kenniscentrum" title={d.h1} description={d.intro} image="https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=1920&q=85&auto=format&fit=crop" />
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        {/* Table of contents */}
        <FadeIn>
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100 mb-12">
            <h2 className="font-bold text-gray-900 mb-3">Inhoud</h2>
            <ol className="space-y-2">{d.sections.map((s,i) => <li key={i} className="text-sm"><a href={`#section-${i}`} className="text-[#00897B] hover:underline">{i+1}. {s.title}</a></li>)}</ol>
          </div>
        </FadeIn>

        {/* Sections */}
        {d.sections.map((s,i) => (
          <FadeIn key={i} delay={i * 0.1}>
            <div id={`section-${i}`} className="mb-12">
              <h2 className="text-xl font-bold text-gray-900 mb-4">{s.title}</h2>
              <p className="text-gray-600 leading-relaxed whitespace-pre-line">{s.content}</p>
            </div>
          </FadeIn>
        ))}

        {/* FAQ */}
        <FadeIn>
          <h2 className="text-xl font-bold text-gray-900 mb-6">Veelgestelde vragen</h2>
          <Accordion type="single" collapsible className="space-y-3">
            {d.faq.map((f,i) => (
              <AccordionItem key={i} value={`q-${i}`} className="bg-gray-50 border border-gray-100 rounded-xl px-6 data-[state=open]:bg-[#00897B]/5 data-[state=open]:border-[#00897B]/20 transition-colors">
                <AccordionTrigger className="text-left font-semibold text-gray-900 hover:text-[#00897B] py-5 text-sm hover:no-underline">{f.q}</AccordionTrigger>
                <AccordionContent className="text-gray-600 leading-relaxed pb-5 text-sm">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          {/* CTA */}
          <div className="mt-12 bg-[#0d1b2a] rounded-xl p-8 text-center">
            <h3 className="text-2xl font-bold text-white mb-3">Op zoek naar een interim finance professional?</h3>
            <p className="text-white/70 text-sm mb-6">Staffing Force Nederland levert gemiddeld binnen 48-72 uur de juiste match.</p>
            <div className="flex gap-4 justify-center">
              <Link to="/opdracht-opgeven" className="bg-[#00897B] hover:bg-[#00796B] text-white px-6 py-3 rounded font-semibold text-sm transition-all hover:-translate-y-0.5 inline-flex items-center gap-2">Opdracht opgeven <ArrowRight size={16} /></Link>
              <Link to="/vacatures" className="border border-white/30 text-white px-6 py-3 rounded font-semibold text-sm hover:border-white transition-all">Bekijk vacatures</Link>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>
  </main>
);

export default GidsInterimFinancePage;
